import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-detalhes-super-social',
  templateUrl: './detalhes-super-social.component.html',
  styleUrls: ['./detalhes-super-social.component.scss']
})
export class DetalhesSuperSocialComponent { }
